import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ar from './locales/ar'
import en from './locales/en'

// Detect locale from URL path before React mounts — no flash on first render.
const pathLocale = window.location.pathname.split('/')[1]
const initialLocale = pathLocale === 'en' ? 'en' : 'ar'

// Initialise SYNCHRONOUSLY at module load with both locales already seeded.
// Calling init() synchronously (not behind an async import) means useTranslation()
// is never invoked before init has started — so react-i18next never returns the
// passthrough `t` that echoes raw keys, and no untranslated keys ever paint.
// Seeding both locales up front also makes the language toggle instant with no flash.
i18n.use(initReactI18next).init({
  resources: {
    ar: { translation: ar },
    en: { translation: en },
  },
  lng: initialLocale,
  fallbackLng: 'ar',
  interpolation: { escapeValue: false },
  react: { useSuspense: true },
})

export default i18n
